<template>
  <zen-one :showuserinfo="false" title="" :crumbs="crumbs">
    <z-page title="Carian Laporan Anak ET">
      <div class="table_scrol">
         <div class="w-card__content content-hardcode mb3">
          <w-form v-model="valid" @validate="cari" ref="frm">

            <w-flex class="mt3 filter-row">
               <div class="filter-col">
                  <z-select style="margin:5px;" :items="negeri" label="Negeri"  v-model="pencarian.lkp_negeri_id"  @input="getBandar()" />
               </div>
               <div class="filter-col">
                  <z-select style="margin:5px;" :items="bandar" class="mt4" label="Daerah"  v-model="pencarian.lkp_bandar_id" />
               </div>
               <div class="filter-col">
                  <w-select style="margin:5px;"
                    :items="lkp_ternakan" 
                    label="Jenis Ternakan" 
                    v-model="pencarian.lkp_ternakan_id" 
                    @input="getJurusan(pencarian.lkp_ternakan_id)"
                  />
               </div>
            </w-flex>
            <w-flex class="mt3 filter-row">
               <div class="filter-col">
                  <w-select style="margin:5px;"
                      :items="lkp_jurusan" 
                      label="Jurusan Ternakan"  
                      v-model="pencarian.lkp_jurusan_id" 
                    />
               </div>
               <div class="filter-col">
              <!-- <w-input class="mt4" label="Tarikh Lahir" type="date" v-model="pencarian.tarikh_lahir"/>   -->
                  <w-input 
                    label="Tarikh Lahir Dari" 
                    type="date" 
                    v-model="pencarian.tarikh_lahir_dari"
                  />
               </div>
               <div class="filter-col">
                  <w-input 
                    label="Tarikh Lahir Hingga" 
                    type="date" 
                    v-model="pencarian.tarikh_lahir_hingga"
                  />
               </div>
            </w-flex>
          </w-form>
          <br>
          <w-flex justify-end class="mt2">
              <w-button class="mr2" v-on:click="resetPencarian()" bg-color="warning">
                  <w-icon>fal fa-redo</w-icon>&nbsp;SET SEMULA</w-button>
              <w-button class="mr2" bg-color="primary" @click="$refs.frm.validate()">
                  <w-icon>fal fa-search</w-icon>&nbsp;CARI
              </w-button>
          </w-flex>
        </div>
         <w-card title-class="blue-dark4--bg white" style="font-size: 13px;" :title="'SENARAI LAPORAN ANAK ET'">
          <template #title>
            SENARAI LAPORAN ANAK ET
          </template>
            <w-flex justify-end class="mt2">
                <w-button bg-color="success" v-on="on" @click="createExcel()" class="mr2">
                    <w-icon class="mr1" md >fal fa-download</w-icon>Muat Turun Excel
                </w-button>
            </w-flex>
            <br>
          <div class="w-table-wrap" style="max-height: 900px;">
            
            <div class="table-profil-scrol">
              <br><br>
              <table class="w-table" color="light" style="border:1px" width="100%">
                <thead>
                  <tr class="w-table__header text-center" style="border: 1px solid #000;">
                    <th class="w-table__header text-center" style="border: 1px solid #000; background:#d6e4f5;" width="1%" rowspan="2">BIL</th>
                    <th class="w-table__header text-center" style="border: 1px solid #000; background:#d6e4f5;" width="23%" colspan="3">Maklumat Penternak</th>
                    <th class="w-table__header text-center" style="border: 1px solid #000; background:#d6e4f5;" width="25%" colspan="6">Maklumat Induk Penderma</th>
                    <th class="w-table__header text-center" style="border: 1px solid #000; background:#d6e4f5;" width="25%" colspan="6">Maklumat Pejantan</th>
                    <th class="w-table__header text-center" style="border: 1px solid #000; background:#d6e4f5;" width="1%" rowspan="2">Tarikh Et</th>
                    <th class="w-table__header text-center" style="border: 1px solid #000; background:#d6e4f5;" width="25%" colspan="7">Maklumat Anak</th>
                  </tr>
                  <tr class="w-table__header text-center" style="border: 1px solid #000;">
                  <!-- Penternak -->
                    <th class="w-table__header text-center" style="border: 1px solid #000; background:#d6e4f5;">Nama Penternak</th>
                    <!-- <th class="w-table__header text-center" style="border: 1px solid #000; background:#d6e4f5;">ID Penternak</th> -->
                    <th class="w-table__header text-center" style="border: 1px solid #000; background:#d6e4f5;">ID Premis</th>
                    <th class="w-table__header text-center" style="border: 1px solid #000; background:#d6e4f5;">Daerah</th>
                  <!-- Induk -->
                    <th class="w-table__header text-center" style="border: 1px solid #000; background:#d6e4f5;">Jenis Ternakan</th>
                    <th class="w-table__header text-center" style="border: 1px solid #000; background:#d6e4f5;">Jurusan Ternakan</th>
                    <th class="w-table__header text-center" style="border: 1px solid #000; background:#d6e4f5;">No. Pendaftaran</th>
                    <th class="w-table__header text-center" style="border: 1px solid #000; background:#d6e4f5;">ID Tag</th>
                    <th class="w-table__header text-center" style="border: 1px solid #000; background:#d6e4f5;">Nama</th>
                    <th class="w-table__header text-center" style="border: 1px solid #000; background:#d6e4f5;">Baka</th>
                  <!-- Pejantan -->
                    <th class="w-table__header text-center" style="border: 1px solid #000; background:#d6e4f5;">Jenis Ternakan</th>
                    <th class="w-table__header text-center" style="border: 1px solid #000; background:#d6e4f5;">Jurusan Ternakan</th>
                    <th class="w-table__header text-center" style="border: 1px solid #000; background:#d6e4f5;">No. Pendaftaran</th>
                    <th class="w-table__header text-center" style="border: 1px solid #000; background:#d6e4f5;">ID Tag</th>
                    <th class="w-table__header text-center" style="border: 1px solid #000; background:#d6e4f5;">Nama</th>
                    <th class="w-table__header text-center" style="border: 1px solid #000; background:#d6e4f5;">Baka</th>
                  <!-- Anak -->
                    <th class="w-table__header text-center" style="border: 1px solid #000; background:#d6e4f5;">Jenis Ternakan</th>
                    <th class="w-table__header text-center" style="border: 1px solid #000; background:#d6e4f5;">Jurusan Ternakan</th>
                    <th class="w-table__header text-center" style="border: 1px solid #000; background:#d6e4f5;">Baka</th>
                    <th class="w-table__header text-center" style="border: 1px solid #000; background:#d6e4f5;">Jantina</th>
                    <th class="w-table__header text-center" style="border: 1px solid #000; background:#d6e4f5;">Tarikh Lahir</th>
                    <th class="w-table__header text-center" style="border: 1px solid #000; background:#d6e4f5;">Berat Lahir</th>
                    <th class="w-table__header text-center" style="border: 1px solid #000; background:#d6e4f5;">Kaedah Kelahiran</th>


                  </tr>
                </thead>
                <tbody>
                    <template v-if="items.data.length == 0">
                        <tr class="w-table__row" >
                            <td class="w-table__cell text-center" colspan="24"> Tiada Data.</td>
                        </tr>
                    </template>
                  <template  v-for="(dt, ind) in items.data" :key="dt.id">

                    <tr class="w-table__row">
                        <td class="w-table__cell text-left" style="border: 1px solid #000;">
                        {{ (items.current_page - 1) * items.per_page + ind + 1 }}</td>
                  <!-- Penternak -->
                        <td class="w-table__cell text-left" style="border: 1px solid #000;">{{dt.nama_penternak ?? '-'}}</td>
                        <!-- <td class="w-table__cell text-left" style="border: 1px solid #000;">{{dt.id_penternak}}</td> -->
                        <td class="w-table__cell text-left" style="border: 1px solid #000;">{{dt.id_premis ?? '-'}}</td>
                        <td class="w-table__cell text-left" style="border: 1px solid #000;">{{dt.daerah ?? '-'}}</td>
                  <!-- Induk -->
                        <td class="w-table__cell text-left" style="border: 1px solid #000;">{{dt.jenis_ternakan_induk ?? '-'}}</td>
                        <td class="w-table__cell text-left" style="border: 1px solid #000;">{{dt.jurusan_ternakan_induk ?? '-'}}</td>
                        <td class="w-table__cell text-left" style="border: 1px solid #000;">{{dt.no_pendaftaran_induk ?? '-'}}</td>
                        <td class="w-table__cell text-left" style="border: 1px solid #000;">{{dt.id_tag_induk ?? '-'}}</td>
                        <td class="w-table__cell text-left" style="border: 1px solid #000;">{{dt.nama_induk ?? '-'}}</td>
                        <td class="w-table__cell text-left" style="border: 1px solid #000;">{{dt.baka_induk ?? '-'}}</td>
                  <!-- Jantan -->
                        <td class="w-table__cell text-left" style="border: 1px solid #000;">{{dt.jenis_ternakan_jantan ?? '-'}}</td>
                        <td class="w-table__cell text-left" style="border: 1px solid #000;">{{dt.jurusan_ternakan_jantan ?? '-'}}</td>
                        <td class="w-table__cell text-left" style="border: 1px solid #000;">{{dt.no_pendaftaran_jantan ?? '-'}}</td>
                        <td class="w-table__cell text-left" style="border: 1px solid #000;">{{dt.id_tag_jantan ?? '-'}}</td>
                        <td class="w-table__cell text-left" style="border: 1px solid #000;">{{dt.nama_jantan ?? '-'}}</td>
                        <td class="w-table__cell text-left" style="border: 1px solid #000;">{{dt.baka_jantan ?? '-'}}</td>

                        <td class="w-table__cell text-left" style="border: 1px solid #000;">{{dt.tarikh}}</td>

                  <!-- Aank -->
                        <td class="w-table__cell text-left" style="border: 1px solid #000;">{{dt.jenis_ternakan_anak ?? '-'}}</td>
                        <td class="w-table__cell text-left" style="border: 1px solid #000;">{{dt.jurusan_ternakan_anak ?? '-'}}</td>
                        <td class="w-table__cell text-left" style="border: 1px solid #000;">{{dt.baka_anak ?? '-'}}</td>
                        <td class="w-table__cell text-left" style="border: 1px solid #000;">{{dt.jantina_anak ?? '-'}}</td>
                        <td class="w-table__cell text-left" style="border: 1px solid #000;">{{dt.tarikh_lahir_anak ?? '-'}}</td>
                        <td class="w-table__cell text-left" style="border: 1px solid #000;">{{dt.berat_anak ?? '-'}}</td>
                        <td class="w-table__cell text-left" style="border: 1px solid #000;">{{dt.kaedah_anak ?? '-'}}</td>
                    </tr>
                  </template>
                  

                  <tr class="w-table__row">
                        <td class="w-table__cell text-left" style="border: none;" colspan="25">
                           &nbsp;
                        </td>
                    </tr>
                    <tr class="w-table__row">
                        <td class="w-table__cell text-left" style="border: 1px solid #000; background:#d6e4f5;" colspan="10">
                           JUMLAH KELAHIRAN ANAK AI JANTAN (EKOR)
                        </td>
                        <td class="w-table__cell text-center" style="border: 1px solid #000; background:#d6e4f5;" colspan="3">
                           {{jumlah_jantan}}
                        </td>
                    </tr>
                    <tr class="w-table__row">
                        <td class="w-table__cell text-left" style="border: 1px solid #000; background:#d6e4f5;" colspan="10">
                           JUMLAH KELAHIRAN ANAK AI BETINA (EKOR)
                        </td>
                        <td class="w-table__cell text-center" style="border: 1px solid #000; background:#d6e4f5;" colspan="3">
                           {{jumlah_betina}}
                        </td>
                    </tr>
                    <tr class="w-table__row">
                        <td class="w-table__cell text-left" style="border: 1px solid #000; background:#d6e4f5;" colspan="10">
                           JUMLAH KESELURUHAN KELAHIRAN ANAK AI (EKOR)
                        </td>
                        <td class="w-table__cell text-center" style="border: 1px solid #000; background:#d6e4f5;" colspan="3">
                           {{jumlah_keseluruhan}}
                        </td>
                    </tr>
                </tbody>
              </table>
              <br><br>
            </div>
          </div>
           
          <table style="border:none;" width="100%">
                <tbody>
                    <tr>
                        <td style="border: none; " width="75%" >
                            <div class="per-page-control">
                                <label for="perPage" class="per-page-label">Rekod per halaman : </label>
                                <select v-model="perPage" @change="changePerPage" id="perPage" class="per-page-select">
                                    <option v-for="opt in perPageOptions" :key="opt" :value="opt">
                                       {{ opt }}
                                    </option>
                                </select>
                            </div>
                        </td>
                        <td style="border: none; " width="25%"  align="right">
                            <nav class="pagination">
                              <button
                              class="pagination-btn"
                              :disabled="!items.prev_page_url"
                              @click="paginate(items.prev_page_url)"
                              >
                                Sebelumnya 
                              </button>

                              <span class="pagination-info">
                                {{ items.current_page }} dari {{ items.last_page }}
                              </span>
                             

                              <button
                              class="pagination-btn"
                              :disabled="!items.next_page_url"
                              @click="paginate(items.next_page_url)"
                              >
                                Seterusnya
                              </button>
                            </nav>
                        </td>
                    </tr>
                </tbody>
            </table>
        </w-card>

       <!--   <z-table title="Senarai Permohonan Baka" :headers="table.headers" :items="table.items" :meta="table.meta" :mobile-breakpoint="700">
         </z-table>
 -->

      </div>
    </z-page>
  </zen-one>
</template>

<script>
import { reactive } from 'vue'
import ZResource from '@/Modules/z-resource'

export default {
  extends: ZResource,
  props: {
    items: [Array, Object],
    jumlah_per_page: Number,
    jumlah_keseluruhan: Number,
    jumlah_jantan: Number,
    jumlah_betina: Number,
    segmenName: [Array, Object]
  },
  data() {
    return {
      resourceurl: 'laporan.anak.et'+this.segmenName,
      crumbs: [
        { label: this.$page.props.app_name, route: '/home' },
        { label: 'Laporan KPI', route: '/laporan' },
        { label: 'Anak ET', route: 'laporan/anak/et' },
      ],
      // perPage: this.$page.props.items?.per_page || 1,
      form : this.datas,
      

      pencarian: {
         lkp_negeri_id: '',
         lkp_bandar_id: '',
         lkp_jenis_baka_id: '',
         lkp_ternakan_id: '',
         lkp_jurusan_id: '',
         tarikh_lahir_dari: '',
         tarikh_lahir_hingga: '',
      },
      negeri:[],
      bandar:[],
      lkp_jurusan :[],
      lkp_ternakan : [],
      
      perPageOptions: [5, 10, 50, 99],
      perPage: this.items.per_page || 10,
      
      
    }
  },
  methods: {
    paginate(url) {
    this.$inertia.get(url, {}, {
      preserveState: true,
      preserveScroll: true,
    });
    },

    changePerPage() {
        let params = {
            ...this.pencarian,
            per_page: this.perPage,
            page: 1
        };
        this.$inertia.visit(route(route().current(), params), {
            preserveState: true,
            preserveScroll: true,
        });
    },
   
   cari() {
       if(!this.valid) return;

       let params = {
       ...this.pencarian,
       };
       params.page = 1;
       this.$inertia.visit(route(route().current(), params), {
           preserveState: true,
           preserveScroll: true,
       });
    },

    resetPencarian() {
       this.$inertia.visit(route(route().current()));
    },

    
   getJenisBaka(){
      this.$zcomm.get(this.api_service + 'lookup/jenis_baka', {}).then(res => {
        this.lkp_jenis_baka = res
      })
    },

   getNegeri(){
        this.$zcomm.get(this.api_service + 'lookup/negeri/'+1, {}).then(res => {
          this.negeri = res

        })
      },
   getBandar(){
        this.$zcomm.get(this.api_service + 'lookup/bandar/'+this.pencarian.lkp_negeri_id, {}).then(res => {
          this.bandar = res
        })
      },
    getTernakan(){
         this.$zcomm.get(this.api_service + 'lookup/ternakan', {}).then(res => {
           this.lkp_ternakan = res
         })
       },

    getJurusan(i){
         this.$zcomm.get(this.api_service + 'lookup/jurusan/'+i, {}).then(res => {
           this.lkp_jurusan = res
         })
       },

   createExcel() {
    const params = {
         lkp_negeri_id: this.pencarian.lkp_negeri_id || '',
         lkp_bandar_id: this.pencarian.lkp_bandar_id || '',
         lkp_jenis_baka_id: this.pencarian.lkp_jenis_baka_id || '',
         lkp_ternakan_id: this.pencarian.lkp_ternakan_id || '',
         lkp_jurusan_id: this.pencarian.lkp_jurusan_id || '',
         tarikh_lahir_dari: this.pencarian.tarikh_lahir_dari || '',
         tarikh_lahir_hingga: this.pencarian.tarikh_lahir_hingga || '',
         excel: 1 // penanda untuk generate Excel
      };
      const queryString = new URLSearchParams(params).toString();
      const url = route('kpi.anak.et') + '?' + queryString;

      window.open(url, '_blank');

   
  }





  },

  watch: {

  },

  mounted() {
   this.getJenisBaka();
   this.getNegeri(); 
   this.getTernakan();
   // this.getJurusan();
    // override default setting
    this.dialog.width = 500
      
  },
}
</script>

<style>
.pagination {
  display: flex;
  align-items: center;
  gap: 1rem;
  margin-top: 1rem;
}

.pagination-btn {
  background-color: #007bff;
  color: white;
  padding: 5px 12px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}

.pagination-btn:disabled {
  background-color: #ccc;
  cursor: not-allowed;
}

.pagination-info {
  font-weight: bold;
}
.w-table thead tr:nth-child(1) th {
  position: sticky;
  top: 2px;
  background: #fff;
  z-index: 3;
}

/* Header baris kedua */
.w-table thead tr:nth-child(2) th {
  position: sticky;
  top: 32px; /* sesuaikan dengan tinggi row pertama */
  background: #fff;
  z-index: 2;
}

.role-selector {
  width: 100%;
  max-width: 400px;
  border: 2px solid #1976d2;
  border-radius: 8px;
  background-color: #f5f5f5;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  font-weight: bold;
}

.role-selector .w-select__selection {
  padding: 12px 16px;
  font-size: 16px;
}

.role-selector .w-select__label {
  font-weight: bold;
  color: #1976d2;
}
.filter-row {
  display: flex;
  gap: 10px;
}

.filter-col {
  flex: 1;
  min-width: 220px; /* optional – elak jadi terlalu kecil */
}
</style>
